import type { SkillDef } from "../types";
import { fmt, nz, prob } from "../util";

function hint(n: number): string {
  if (n >= 100) {
    const h = Math.floor(n / 100) * 100, r = n % 100;
    return `(${fmt(h)} + ${r})² = ${fmt(h)}² + 2×${fmt(h)}×${r} + ${r}²\n= ${fmt(h * h)} + ${fmt(2 * h * r)} + ${fmt(r * r)} = ${fmt(n * n)}`;
  }
  if (n < 10) return `Know it cold: ${n}×${n} = ${n * n}`;
  if (n % 10 === 5) { const a = Math.floor(n / 10); return `Ends in 5: ${a}×${a + 1} = ${a * (a + 1)}, append 25 → ${fmt(n * n)}`; }
  if (n % 10 === 0) return `${n / 10}² = ${(n / 10) ** 2}, append 00 → ${fmt(n * n)}`;
  const r = Math.round(n / 10) * 10, d = Math.abs(n - r), lo = n - d, hi = n + d;
  return `Nearest ten: ${n}² = ${lo}×${hi} + ${d}² = ${fmt(lo * hi)} + ${d * d} = ${fmt(n * n)}`;
}

const RANGE: Record<number, [number, number]> = {
  1: [2, 12], 2: [13, 20], 3: [21, 30], 4: [31, 50], 5: [51, 75],
  6: [76, 100], 7: [101, 125], 8: [126, 200], 9: [201, 400], 10: [401, 999],
};

export const sq: SkillDef = {
  key: "sq", name: "Squares", blurb: "up to 3 digits", start: 1,
  generate(L, r) {
    const [lo, hi] = RANGE[L];
    let n = r.int(lo, hi);
    if (L === 3 && r.float() < 0.4) n = 15 + 10 * r.int(0, 8);
    const t = n <= 12 ? 2.5 : n % 10 === 0 ? 3 : n % 10 === 5 && n < 100 ? 4 : n < 50 ? 6 : n < 100 ? 8 : 10 + 2.5 * nz(n % 100);
    return prob(`${n}²`, n * n, hint(n), { t });
  },
};
